import React from "react";

const ClipartElement = ({
  clipart,
  layerId,
  selectedClipartId,
  onChooseClipart,
  setSelectedClipartId,
  defaultImageSize,
}) => {
  const clipartId = clipart.id,
    selected = selectedClipartId === clipartId ? "selected" : "";

  const handleClick = () => {
    onChooseClipart({ clipart, type: "clipart", layerId, defaultImageSize });
    setSelectedClipartId(clipartId);
  };

  let url = process.env.REACT_APP_TEXT_EFFECTS_URL
  url += `clipart?id=${clipart.id}&size=small`

  return (
    <div className={`clipart__item ${selected}`} onClick={handleClick}>
      <img src={clipart.thumbnail ?? url} alt={clipart.name} className="clipart__image" />
    </div>
  );
};

export default ClipartElement;
